/* eslint-disable camelcase, class-methods-use-this, no-undef, no-underscore-dangle */
import { deleteCookie } from "init/cookie";
import { clearFilters, filtersChanged, not_default } from "init/filters";
import { Controller } from "stimulus";

import Comparison from "../comparison_modal/model";
import { loadModalUrl } from "../modal/utils";

export default class extends Controller {
  static targets = [
    "toggleContainer",
    "compareButton",
    "suggestions",
    "suggestionsList",
    "suggestionsButton"
  ];

  closeAllSelects(el) {

    document.querySelectorAll(".custom-select").forEach(select => {
      if (select !== el) {
        select.classList.remove("open");
        const selectItemsWrapper = select.querySelector(".select-items-wrapper")
        if (selectItemsWrapper) {
          selectItemsWrapper.classList.add("select-hide");
        }
          
        select.dispatchEvent(new CustomEvent("toggle-select"));
      }
    });
  }

  connect() {
    this.sortFilter = this.element.querySelector(".sort-filter .custom-select");
    document.addEventListener("click", this.closeFilter.bind(this));
    this.sortFilter.addEventListener(
      "toggle-select",
      this.toggleSortFilter.bind(this)
    );
    this.sortFilter.addEventListener("change", this.changeSort.bind(this));
    this.formTarget = document.querySelector(".plp-filter form");
    this.plpBarTarget = document.querySelector(".plp-bar");
    this.listingsGridTarget = document.querySelector(".listings-grid");
    this.filtersChanged();
    this.notifyNoResults();

    if (
      document.cookie
        .split(";")
        .filter(c => c.trim().startsWith("filter_by_dates=")).length !== 0
    ) {
      this.removeStartingPriceText();
    }

    this.setupEndlessPaginate();
  }

  removeStartingPriceText() {
    document
      .querySelectorAll(".listing-price .starting-price")
      .forEach(e => e.remove());
  }

  changeSort(e) {
    const sortBy = e.target.querySelector("select").value;
    const params = Site.serializedQueryParams();

    let destination = window.location.pathname;
    /* eslint-disable-next-line eqeqeq */
    if (sortBy == 0) {
      delete params.sort_by;
    } else {
      Object.assign(params, { sort_by: sortBy });
    }

    if (Object.keys(params).length) {
      destination = `${destination}?${Site.objectToQuery(params)}`;
    }
    window.location = destination;
  }

  openPlpBar(e) {
    const evt = new Event('plp-bar-open');
    window.dispatchEvent(evt);
  }

  clearAllFilters(e) {
    deleteCookie("filter_by_dates");
    this.clearFilters(e);
    const queryData = Site.serializedQueryParams();
    const destinations = document.getElementById("destinations").value;
    let path = `${window.location.origin}/stay`;
    if (location.pathname.includes("/special-offers/")) {
      path = `${window.location.origin}${location.pathname}`;
    }
    let params = {};
    if (destinations.length) {
      params.destinations = destinations;
      //path = `${path}?destinations=${destinations}`;
    }

    if (queryData.coupon) {
      params.coupon = queryData.coupon;
    }
    let query = Site.objectToQuery(params);
    if (query == "") {
      window.location = path;
    } else {
      window.location = `${path}?${query}`;
    }
  }

  clearFilters = clearFilters;

  filtersChanged = filtersChanged;

  not_default = not_default;

  clearDates() {
    // Cookie set by TrackConnectController
    deleteCookie("filter_by_dates");

    const queryData = Site.serializedQueryParams();
    let destination = window.location.pathname;

    delete queryData.checkout;
    delete queryData.checkin;

    const query = Site.objectToQuery(queryData);
    /* eslint-disable-next-line eqeqeq */
    destination = query == "" ? destination : `${destination}?${query}`;
    window.location = destination;
  }

  clickSortSelect(e) {
    e.stopPropagation();
    this.sortFilter.querySelector(".select-selected").click();
    this.sortFilter.classList.toggle("open-select");
  }

  // Toggle List Mode
  toggle(e) {
    this.plpBarTarget.classList.toggle("list-mode");
    this.listingsGridTarget.classList.toggle("list-mode");
    const isListMode = this.plpBarTarget.classList.contains("list-mode");
    Cookie.setCookie("list_mode", isListMode, 1);
    const event = new CustomEvent("mount");
    window.dispatchEvent(event);
  }

  // Toggle Sort
  toggleSortFilter(e) {
    if (e.target.querySelector(".select-hide")) {
      this.element.classList.remove("sort-open");
    } else {
      this.element.classList.add("sort-open");
    }

    if (this.element.classList.contains("filter-open")) {
      this.element.classList.remove("filter-open");
    }
    window.dispatchEvent(new CustomEvent("toggle-sort"));
  }

  // Toggle Filter
  toggleFilter(e) {
    e.stopPropagation();
    this.element.classList.toggle("filter-open");
    if (this.element.classList.contains("sort-open")) {
      this.element.classList.remove("sort-open");
      this.element.querySelectorAll(".custom-select, .destinations").forEach((item) => {
        item.classList.remove("open");
      })
      this.element
        .querySelector(".select-items-wrapper")
        .classList.add("select-hide");
    }

    window.dispatchEvent(new CustomEvent("toggle-filter"));
  }

  closeFilter() {
    document
      .querySelectorAll(".listings-grid, .plp-sort-filter")
      .forEach(filter => filter.classList.remove("filter-open"));
  }

  updateComparison() {
    document.querySelectorAll(".compare-checkbox").forEach(checkbox => {
      // Sync
      if (checkbox.checked) {
        const removed = this.comparison().addListing(checkbox.value);

        removed.forEach(id => {
          document
            .querySelectorAll(`.compare-checkbox:checked[value="${id}"]`)
            .forEach(cb => {
              /* eslint-disable-next-line no-param-reassign */
              cb.checked = false;
            });
        });
      } else {
        this.comparison().removeListing(checkbox.value);
      }
    });

    const checked = this.comparison().state().length;
    this.compareButtonTarget.classList.toggle("-active", checked > 1);
  }

  async compare() {
    const params = this.comparison()
      .state()
      .map(id => `listings[]=${encodeURIComponent(id)}`)
      .join("&");

    await loadModalUrl(`/listings/comparison?${params}`);
  }

  comparison() {
    this._comparison = this._comparison || new Comparison();
    return this._comparison;
  }

  notifyNoResults() {
    if (
      document.getElementsByClassName("plp-no-results-container").length > 0
    ) {
      const event = new Event("no-results");
      document.dispatchEvent(event);
    }
  }

  setupEndlessPaginate() {
    this.current_page = 1;
    const search_params = new URLSearchParams(window.location.search);
    if (search_params.has("page"))
      this.current_page = Number(search_params.get("page"));

    this.endless_observer = new IntersectionObserver(async entries => {
      if (entries[0].intersectionRatio <= 0) return;
      if (this.endless_paginate_running) return;

      await this.doEndlessPaginate();
    });

    this.endless_observer.observe(window.document.querySelector(".pagination"));
  }

  async doEndlessPaginate() {
    if (this.endless_paginate_running) return;

    const url = new URL(window.location);

    this.current_page += 1;
    url.searchParams.set("page", this.current_page.toString());

    const history_url = url.toString();
    this.endless_paginate_running = true;
    url.searchParams.set("skip", 1);
    await fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content
      }
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const list = this.element.querySelector("ul.grid");

        const total_children = doc.querySelector(".items").childElementCount;

        while (doc.querySelector(".items").childElementCount > 0) {
          const item = doc.querySelector(".items").children[0];
          list.appendChild(item);
        }

        window.document
          .querySelector(".pagination")
          .replaceWith(doc.querySelector(".pagination"));
        this.endless_observer.observe(
          window.document.querySelector(".pagination")
        );

        window.history.pushState({ page: this.current_page }, "", history_url);
        this.endless_paginate_running = false;
      })
      .catch(_err => (this.endless_paginate_running = true));
  }

  async load_suggestions() {
    const queryData = Site.serializedQueryParams();
    const queryParams = JSON.parse(this.suggestionsTarget.dataset.params);
    queryParams.except = JSON.parse(this.suggestionsTarget.dataset.except);
    const queryString = Site.objectToQuery(
      Object.assign(queryParams, queryData)
    );

    this.suggestionsTarget.classList.add("suggestions--loading");
    await fetch(`/stay/recommendations?${queryString}`)
      .then(response => response.text())
      .then(body => {
        if (body !== "") {
          this.suggestionsListTarget.innerHTML = body;
          this.suggestionsTarget.classList.remove("suggestions--lazy");
          this.suggestionsTarget.classList.add("suggestions--loaded");
        } else {
          this.suggestionsButtonTarget.style.display = "none";
          document.querySelector(".suggestions-title").style.display = "none";
          document.querySelector(".suggestions-subtitle").innerText =
            "Sorry, but we do not have any recommendations for your selected dates. Please adjust your dates.";
        }
      })
      .then(() => {
        this.suggestionsTarget.classList.remove("suggestions--loading");
      })
      .catch(err => console.error(err));
  }
}
